export * from './Atributo'